import * as React from 'react';
import { connect } from 'react-redux';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import 'font-awesome/css/font-awesome.css';
import './assets/documentViewer.css';
import { DatabasesToSearch } from '../shared/databasesToSearch';

export interface IViewAllButtonProps {
  reportId: number;
  className?: string;
  size?: string;
  text?: string;
  dbToSearch?: DatabasesToSearch;
  managementMode?: boolean;
}
export interface IViewAllButtonState {
  showComments: boolean;
}
const initialState: IViewAllButtonState = {
  showComments: false,
};
class ViewAllButton extends React.Component<
  IViewAllButtonProps,
  IViewAllButtonState
> {
  windowRef: any;

  public constructor(props: IViewAllButtonProps) {
    super(props);
    this.state = initialState;
  }

  static defaultProps = {
    dbToSearch: DatabasesToSearch.Private
  }

  componentDidMount() { }

  handleClick = () => {
    let url = `/DocumentViewer?r=${this.props.reportId}&dbToSearch=${this.props.dbToSearch}`;
    if(this.props.managementMode){
      url = url + `&m=m`;
    }
    window.open(url, '_blank', 'width=1300,height=900');
  };

  public render() {
    const placement = 'top';
    return (
      <React.Fragment>
        <OverlayTrigger
          key={placement}
          placement={placement}
          overlay={
            <Tooltip id={`tooltip-${placement}`}>
              <strong>View All Related Documents</strong>.
            </Tooltip>
          }
        >
          <Button
            variant={'secondary'}
            size={this.props.size == 'lg' ? 'lg' : 'sm'}
            className={this.props.className}
            id={`commentBtn${this.props.reportId}`}
            key={`commentBtn${this.props.reportId}`}
            onClick={() => this.handleClick()}
          >
            <i className='fas fa-file-invoice'></i> {this.props.text}
          </Button>
        </OverlayTrigger>
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {};
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewAllButton);
